import { RootState } from '@/store/types';
import { CoursesState } from '@/store/courses/types';
import _ from 'lodash'
import axios from 'axios';
import { ActionTree } from 'vuex';
import { getPagerFromApiResponse } from '@/store/utils';
import { Extra, ExtraConditions } from '@/store/extras/types';
import moment from 'moment'

const actions: ActionTree<CoursesState, RootState> = {
  /**
   * エクストラ一覧
   * @param { number } page ページ
   * @param { ExtraConditions } conditions 検索条件
   */
  fetchExtras: async (
    { commit },
    { page, conditions }: { page: number, conditions: ExtraConditions },
  ) => {
    const { data, headers } = await axios.get('/tutors/extraLessons', {
      params: {
        page,
        ..._.pickBy({
          tutor: conditions?.tutorNameOrId,
          positionCode: conditions?.positions?.map(({ code }) => code).join(','),
          yearMonth: conditions?.yearMonth?.format('YYYYMM'),
        }),
      },
    });

    const extras = _.map(data, (extra: any): Extra => {
      return {
        tutor: {
          id: extra.tutorId,
          name: extra.tutorName,
        },
        yearMonth: moment(extra.yearMonth, 'YYYYMM'),
        position: extra.position,
        extraLesson: extra.extraLesson,
      }
    });

    commit('fetchedExtras', {
      pager: getPagerFromApiResponse(page, headers),
      extras,
    })
  },
};

export default actions;
